export namespace QueuePlacePnrNS {
  export interface QueuePlacePnrRequest {
    targetDetails: TargetDetail[];
    selectionDetails: string;
    reservationControlNumber?: string;
  }

  export interface TargetDetail {
    targetOffice: TargetOffice;
    queueNumber: number;
    categoryDetails: CategoryDetails;
    placementDate?: PlacementDate;
  }

  export interface TargetOffice {
    sourceQualifier1: string;
    inHouseIdentification1: string;
  }

  export interface CategoryDetails {
    identificationType: string;
    itemNumber: string;
    itemDescription?: string;
  }

  export interface PlacementDate {
    timeMode: number;
    dateTime: DateTime;
  }

  export interface DateTime {
    year: string;
    month: string;
    day: string;
    hour?: string;
  }

  export interface QueuePlacePnrResponse {
    errorReturn: ErrorReturn;
    reservationControlNumber: string;
  }

  export interface ErrorReturn {
    errorDetails: ErrorDetails;
    errorText: ErrorText;
  }

  export interface ErrorDetails {
    errorCode: string;
    errorCategory: string;
    errorCodeOwner: string;
  }

  export interface ErrorText {
    textSubjectQualifier: string;
    source: string;
    encoding: string;
    freeText: string[];
  }

  export const enum QueueType {
    'Refund' = 'Refund',
    'TicketingFailure' = 'TicketingFailure',
  }
}
